import { useEffect, useState } from 'react'
import { Icon } from 'assets/index'
import { InfoCard } from 'components/index'
import { IObject, IResponse } from 'interfaces'
import useFetch from 'hooks/useFetch'
import { DICTIONARY } from 'configs/configs.js'
import Document from './Document'

interface IProps {
  accountData: {
    [_key: string]: any
    account?: IObject
  }
  readonly?: boolean
}

const optionsCivil = [
  { label: 'Solteiro', value: 'SINGLE' },
  { label: 'Casado', value: 'MARRIED' },
  { label: 'Divorciado', value: 'DIVORCED' },
  { label: 'Viúvo', value: 'WIDOWER' },
]

const pixSelectOptions = [
  { value: 'CPF', label: 'CPF' },
  { value: 'CNPJ', label: 'CNPJ' },
  { value: 'PHONE', label: 'Número de Telefone' },
  { value: 'EMAIL', label: 'Endereço de E-mail' },
  { value: 'EVP', label: 'Chave Aleatória' },
]

export default function (props: IProps) {
  const { accountData, readonly } = props
  const [account, setAccount] = useState<IObject | undefined>(
    accountData.account
  )

  const api = useFetch(`/gestor/account?id=${accountData.accountId}`)

  useEffect(() => {
    if (accountData.account) return
    api.fetch('get').then(async (r: IResponse) => {
      if (r.fail) throw new Error(r.errors.message)
      const acc = r.data.data
      acc.status =
        DICTIONARY.ACCOUNT[
          acc.account.status as keyof typeof DICTIONARY.ACCOUNT
        ]
      // Seta endereço
      await (async () => {
        if (!acc.address.postalCode) return
        const n = acc.address.postalCode

        const a = await api.fetch('get', null, `/app/get-address/${n}`)

        if (!a.data) return
        acc.address = {
          ...acc.address,
          ...a.data,
        }
      })()
      setAccount(acc)
    })
  }, [])

  if (!account || !('account' in account)) return null
  return (
    <>
      <div className="status-card-container-cards">
        <InfoCard
          icon={Icon('calendar.svg')}
          value={account?.account?.createdAt}
        >
          Data de criação
        </InfoCard>{' '}
        <InfoCard
          icon={Icon('calendar.svg')}
          value={account?.account?.activatedAt}
        >
          Data de ativação
        </InfoCard>{' '}
        <InfoCard icon={Icon('profile.svg')} value={account?.user?.document}>
          CPF
        </InfoCard>{' '}
        <InfoCard icon={Icon('profile.svg')} value={account?.user?.rg}>
          RG
        </InfoCard>{' '}
        <InfoCard
          icon={Icon('profile.svg')}
          value={
            optionsCivil.find(
              (item: any) => item.value === account?.user?.civilState
            )?.label || ''
          }
        >
          Estado civil
        </InfoCard>{' '}
        <InfoCard icon={Icon('calendar.svg')} value={account?.user?.birthDate}>
          Data de nascimento
        </InfoCard>
        {account?.address?.postalCode ? (
          <>
            <InfoCard
              icon={Icon('pin.svg')}
              value={account?.address?.postalCode}
            >
              CEP
            </InfoCard>
            <InfoCard icon={Icon('pin.svg')} value={account?.address?.state}>
              Estado
            </InfoCard>
            <InfoCard icon={Icon('pin.svg')} value={account?.address?.city}>
              Cidade
            </InfoCard>
            <InfoCard icon={Icon('pin.svg')} value={account?.address?.province}>
              Bairro
            </InfoCard>
            <InfoCard icon={Icon('pin.svg')} value={account?.address?.address}>
              Rua
            </InfoCard>
            <InfoCard icon={Icon('pin.svg')} value={account?.address?.number}>
              Número
            </InfoCard>
            <InfoCard
              icon={Icon('pin.svg')}
              value={account?.address?.complement}
            >
              Complemento
            </InfoCard>
          </>
        ) : null}
        <InfoCard
          icon={Icon('whats.svg')}
          value={`+55 ${account?.account?.cellphone}`}
        >
          WhatsApp
        </InfoCard>
        <InfoCard icon={Icon('mail.svg')} value={account?.account?.email}>
          E-mail
        </InfoCard>
        <InfoCard
          icon={Icon('lock_open.svg')}
          value={
            pixSelectOptions.find(
              (item) => item.value === account?.account?.pixList[0]?.type
            )?.label || 'Desconhecido'
          }
        >
          Tipo chave pix
        </InfoCard>
        <InfoCard
          icon={Icon('profile.svg')}
          value={account?.account?.pixList[0]?.key}
        >
          Chave pix
        </InfoCard>
        <InfoCard
          icon={Icon('profile.svg')}
          value={account?.account?.pixList[0]?.institution}
        >
          Banco
        </InfoCard>
      </div>
      <Document
        pf={account?.user?.type === 'CPF'}
        readonly={readonly}
        document={account?.user?.document}
        documentList={account?.account?.documentList}
      />
    </>
  )
}
